import React from "react";
import { Divider, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderUser from "../../header/HeaderUser";
import { useTranslation } from "react-i18next";

const MenuFooter = (props) => {
  const { user } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  // Determine the correct link path based on user role
  const linkPath =
    user?.role === "superadmin"
      ? "/profile/plans"
      : user?.role === "marketing"
      ? "/profile/plans"
      : "/profile/subscription";

  const collapsed = props.collapsed;

  // Custom style for Divider with box shadow
  const dividerStyle = {
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset",
    width: "100%",
  };

  // Common style for footer items - 28px padding to match menu items
  const footerItemStyle = {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    transition: "all 0.2s ease-in-out",
    paddingLeft: "28px", // Same as menu items - icons don't move during expand/collapse
  };

  return (
    <div
      className="hp-sidebar-footer hp-bg-color-dark-90"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        transition: "all 0.2s ease-in-out",
      }}
    >
      <Divider
        className="hp-border-color-black-40 hp-border-color-dark-100 hp-mt-0"
        style={dividerStyle}
      />

      {/* Subscription */}
      {user?.role === "admin" && (
        <Link to={linkPath} style={{ width: "100%" }}>
          <Tooltip
            title={collapsed ? t("navigation.footer.subscription") : ""}
            placement="right"
          >
            <div
              style={{
                ...footerItemStyle,
                marginBottom: collapsed ? "20px" : "23px",
              }}
            >
              <svg
                width="1.7em"
                height="1.7em"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient
                    id="cardGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#60A5FA" />
                    <stop offset="100%" stopColor="#3B82F6" />
                  </linearGradient>
                </defs>
                <rect
                  x="2"
                  y="6"
                  width="20"
                  height="13"
                  rx="1.8"
                  fill="url(#cardGradient)"
                  stroke="#2563EB"
                  strokeWidth="0.8"
                />
                <rect
                  x="3.5"
                  y="8.5"
                  width="3"
                  height="2"
                  rx="0.3"
                  fill="#FBBF24"
                />
                <rect
                  x="3.5"
                  y="12.5"
                  width="7"
                  height="0.6"
                  rx="0.15"
                  fill="white"
                  opacity="0.9"
                />
                <rect
                  x="3.5"
                  y="14"
                  width="6"
                  height="0.6"
                  rx="0.15"
                  fill="white"
                  opacity="0.9"
                />
                <rect
                  x="3.5"
                  y="15.5"
                  width="4"
                  height="0.6"
                  rx="0.15"
                  fill="white"
                  opacity="0.9"
                />
                <circle cx="16" cy="9.5" r="1" fill="#EF4444" opacity="0.9" />
                <circle cx="17.8" cy="9.5" r="1" fill="#F59E0B" opacity="0.8" />
                <path d="M16.9 9.1L16.9 9.9" stroke="white" strokeWidth="0.4" />
                <text
                  x="18.5"
                  y="17"
                  fontSize="1.5"
                  fill="white"
                  fontFamily="monospace"
                >
                  VISA
                </text>
              </svg>
              <span
                className="hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body"
                style={{
                  marginLeft: "24px",
                  opacity: collapsed ? 0 : 1,
                  width: collapsed ? 0 : "auto",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  transition: "opacity 0.2s ease-in-out, width 0.2s ease-in-out",
                }}
              >
                {t("navigation.footer.subscription")}
              </span>
            </div>
          </Tooltip>
        </Link>
      )}

      {/* View Profile */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          minHeight: "50px",
          paddingLeft: collapsed ? "17px" : "22px",
          transition: "padding-left 0.2s ease-in-out",
        }}
      >
        <HeaderUser placement="topRight" />

        <div
          className="hp-mt-6"
          style={{
            marginLeft: "10px",
            opacity: collapsed ? 0 : 1,
            width: collapsed ? 0 : "auto",
            overflow: "hidden",
            whiteSpace: "nowrap",
            transition: "opacity 0.15s, width 0.15s",
          }}
        >
          <span className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body">
            {user?.name}
          </span>

          <Link
            to="/profile/information"
            className="hp-badge-text hp-text-color-dark-30 hp-font-weight-400"
            onClick={props.onClose}
          >
            {t("navigation.footer.viewProfile")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MenuFooter;
